import React, { useEffect, useRef } from 'react'
import { Box } from '@material-ui/core'

import useStyles from './styles'

const FakePageView = ({ html }) => {
  const classes = useStyles()
  const iframeRef = useRef(null)

  useEffect(() => {
    const iframe = iframeRef.current
    if (!iframe || !html) return

    const doc = iframe.contentDocument || iframe.contentWindow?.document
    if (!doc) return

    const sanitized = html.replace(/<script[\s\S]*?<\/script>/gi, '')
    doc.open()
    doc.write(sanitized)
    doc.close()
  }, [html])

  return (
    <Box className={classes.wrapper}>
      <Box className={classes.overlay} />
      <iframe
        ref={iframeRef}
        title="Página de phishing"
        className={classes.iframe}
      />
    </Box>
  )
}

export default FakePageView
